// extracted by mini-css-extract-plugin
module.exports = {"ErrorScreen":"Error_ErrorScreen__1wduu","ErrorMessage":"Error_ErrorMessage__1qc9B","RestartTitle":"Error_RestartTitle__2Qy64"};